


  import dep0 from "@universal-ember/react/-embroider-implicit-modules.js";
  import dep1 from "@ember/test-helpers/-embroider-implicit-modules.js";
  import dep2 from "@embroider/router/-embroider-implicit-modules.js";
  import dep3 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep4 from "ember-cli-babel/-embroider-implicit-modules.js";
  import dep5 from "ember-data/-embroider-implicit-modules.js";
  import dep6 from "ember-modifier/-embroider-implicit-modules.js";
  import dep7 from "ember-page-title/-embroider-implicit-modules.js";
  import dep8 from "ember-qunit/-embroider-implicit-modules.js";
  import dep9 from "ember-simple-auth/-embroider-implicit-modules.js";
  import dep10 from "ember-simple-auth-token/-embroider-implicit-modules.js";
  import dep11 from "ember-welcome-page/-embroider-implicit-modules.js";
  import dep12 from "tracked-built-ins/-embroider-implicit-modules.js";
  import dep13 from "@ember/optional-features/-embroider-implicit-modules.js";
  import dep14 from "@embroider/macros/-embroider-implicit-modules.js";
  import dep15 from "ember-auto-import/-embroider-implicit-modules.js";
  import dep16 from "@glimmer/tracking/-embroider-implicit-modules.js";
  import dep17 from "ember-cli-deploy/-embroider-implicit-modules.js";
  import dep18 from "ember-cli-deploy-build/-embroider-implicit-modules.js";
  import dep19 from "ember-cli-deploy-revision-data/-embroider-implicit-modules.js";
  import dep20 from "ember-cli-deploy-scp/-embroider-implicit-modules.js";
  import dep21 from "ember-cli-dotenv/-embroider-implicit-modules.js";
  import dep22 from "ember-cli-htmlbars/-embroider-implicit-modules.js";
  import dep23 from "ember-source/-embroider-implicit-modules.js";
  import dep24 from "ember-toastr/-embroider-implicit-modules.js";

  import * as own0 from "ember-source/ember/index.js";

export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
    dep13,
    dep14,
    dep15,
    dep16,
    dep17,
    dep18,
    dep19,
    dep20,
    dep21,
    dep22,
    dep23,
    dep24,
  {
      "ember/index": own0,
  }
);
